export type Movie = {
  id: string;
  title: string;
  titleEn: string;
  year: number;
  region: string;
  genres: string[];
  rating: number;
  duration: number;
  director: string;
  cast: string[];
  releaseDate: string;
  heat: number;
  poster: string;
  backdrop: string;
  synopsis: string;
};

export const movies: Movie[] = [
  {
    id: 'm-001',
    title: '银河彼岸',
    titleEn: 'Beyond the Galaxy',
    year: 2025,
    region: '美国',
    genres: ['scifi', 'action'],
    rating: 9.1,
    duration: 148,
    director: '埃里克·诺兰',
    cast: ['克里斯·韦恩', '艾米丽·罗森', '大卫·陈'],
    releaseDate: '2025-07-18',
    heat: 9860,
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20astronaut%20facing%20a%20giant%20glowing%20planet%2C%20deep%20navy%20and%20orange%20color%20palette%2C%20dramatic%20lighting%2C%20clean%20minimal%20composition%2C%20high%20detail&width=400&height=600&seq=movie-poster-001&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20spaceship%20drifting%20toward%20a%20vast%20glowing%20planet%2C%20deep%20blue%20nebula%2C%20warm%20orange%20rim%20light%2C%20epic%20sci-fi%20atmosphere%2C%20high%20detail&width=1200&height=675&seq=movie-back-001&orientation=landscape',
    synopsis: '一支执行深空勘探任务的团队在银河边缘发现了一颗会“呼吸”的星球。随着通讯中断与能源枯竭，他们必须在信任崩塌之前做出选择。影片以宏大的视觉语言探讨了孤独、信念与文明的边界。',
  },
  {
    id: 'm-002',
    title: '雾都追凶',
    titleEn: 'Fog City Chase',
    year: 2025,
    region: '中国大陆',
    genres: ['thriller', 'drama'],
    rating: 8.4,
    duration: 122,
    director: '林嘉树',
    cast: ['张弼', '许静', '陈默'],
    releaseDate: '2025-05-30',
    heat: 8340,
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20movie%20poster%20of%20a%20detective%20silhouette%20in%20dense%20fog%20on%20a%20rainy%20street%2C%20moody%20dark%20blue%20tones%20with%20a%20single%20orange%20street%20light%2C%20tense%20atmosphere%2C%20high%20detail&width=400&height=600&seq=movie-poster-002&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20rainy%20city%20street%20at%20night%20covered%20in%20fog%2C%20neon%20reflections%20on%20wet%20asphalt%2C%20deep%20blue%20mood%20with%20warm%20orange%20accent%20lights%2C%20film%20noir%20atmosphere%2C%20high%20detail&width=1200&height=675&seq=movie-back-002&orientation=landscape',
    synopsis: '一桩沉寂十年的旧案随着一盘匿名磁带再度浮出水面。退休刑警与年轻记者在浓雾笼罩的城市里追寻真相，却发现每个人都藏着不愿被翻开的一页。',
  },
  {
    id: 'm-003',
    title: '夏日回响',
    titleEn: 'Echoes of Summer',
    year: 2024,
    region: '日本',
    genres: ['romance', 'drama'],
    rating: 8.7,
    duration: 116,
    director: '佐藤遥',
    cast: ['新垣里奈', '木村悠真', '小林真央'],
    releaseDate: '2024-08-09',
    heat: 7920,
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20romance%20movie%20poster%20of%20two%20figures%20standing%20on%20a%20seaside%20platform%20at%20sunset%2C%20soft%20warm%20orange%20gradient%20sky%2C%20gentle%20nostalgic%20mood%2C%20clean%20minimal%20composition%2C%20high%20detail&width=400&height=600&seq=movie-poster-003&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20seaside%20town%20at%20golden%20hour%20with%20warm%20orange%20sunset%20clouds%20and%20calm%20sea%2C%20nostalgic%20gentle%20atmosphere%2C%20soft%20natural%20light%2C%20high%20detail&width=1200&height=675&seq=movie-back-003&orientation=landscape',
    synopsis: '小镇的夏天总是很长，长到足以装下一段没有说完的告白。多年后重回故乡的女主角，在一台旧收音机里听见了当年自己录下的声音，也听见了被时光掩埋的约定。',
  },
  {
    id: 'm-004',
    title: '机械之心',
    titleEn: 'The Mechanical Heart',
    year: 2025,
    region: '美国',
    genres: ['scifi', 'action'],
    rating: 8.9,
    duration: 135,
    director: '萨拉·科尔曼',
    cast: ['詹姆斯·卡特', '娜奥米·刘', '奥利弗·雷'],
    releaseDate: '2025-03-14',
    heat: 9150,
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20action%20movie%20poster%20of%20a%20humanoid%20robot%20with%20a%20glowing%20orange%20chest%20core%2C%20dark%20metallic%20background%2C%20deep%20navy%20tones%2C%20dramatic%20industrial%20lighting%2C%20high%20detail&width=400&height=600&seq=movie-poster-004&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20futuristic%20robotics%20laboratory%20with%20glowing%20orange%20core%20lights%20and%20deep%20blue%20shadows%2C%20industrial%20sci-fi%20atmosphere%2C%20high%20detail&width=1200&height=675&seq=movie-back-004&orientation=landscape',
    synopsis: '当第一台真正拥有情感的仿生人走进人类社会，一场关于“什么才算活着”的辩论随之爆发。工程师必须在自己亲手创造的造物与整个城市的安危之间做出抉择。',
  },
  {
    id: 'm-005',
    title: '山那边的云',
    titleEn: 'Clouds Beyond the Mountain',
    year: 2024,
    region: '中国大陆',
    genres: ['drama'],
    rating: 8.2,
    duration: 128,
    director: '苏青',
    cast: ['王砚辉', '周冬雨', '李岷城'],
    releaseDate: '2024-11-02',
    heat: 6210,
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20drama%20movie%20poster%20of%20a%20lone%20figure%20standing%20on%20a%20misty%20mountain%20ridge%20at%20dawn%2C%20soft%20blue%20and%20warm%20orange%20gradient%2C%20serene%20contemplative%20mood%2C%20high%20detail&width=400&height=600&seq=movie-poster-005&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20misty%20mountain%20village%20at%20dawn%20with%20layered%20clouds%20and%20warm%20orange%20sunrise%20light%2C%20calm%20reflective%20atmosphere%2C%20high%20detail&width=1200&height=675&seq=movie-back-005&orientation=landscape',
    synopsis: '一位乡村教师用二十年的时间，把一间漏雨的教室变成了孩子们看世界的窗口。影片以克制的镜头讲述坚守与告别，也讲述那些被大山挡住却从未熄灭的梦想。',
  },
  {
    id: 'm-006',
    title: '爆笑江湖',
    titleEn: 'Laughing Rivers',
    year: 2025,
    region: '中国大陆',
    genres: ['comedy'],
    rating: 7.6,
    duration: 108,
    director: '高鹏',
    cast: ['沈腾', '马丽', '魏翔'],
    releaseDate: '2025-01-25',
    heat: 7480,
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20comedy%20movie%20poster%20of%20three%20quirky%20characters%20in%20colorful%20ancient%20chinese%20costumes%2C%20playful%20bright%20orange%20and%20navy%20palette%2C%20fun%20energetic%20mood%2C%20high%20detail&width=400&height=600&seq=movie-poster-006&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20colorful%20ancient%20chinese%20town%20with%20festive%20lanterns%2C%20playful%20warm%20orange%20and%20deep%20blue%20palette%2C%20energetic%20joyful%20atmosphere%2C%20high%20detail&width=1200&height=675&seq=movie-back-006&orientation=landscape',
    synopsis: '一个没什么本事的客栈掌柜，阴差阳错成了江湖人人争抢的“秘籍传承人”。为了保命也为了守住客栈，他拉上一群不靠谱的伙伴，上演了一出啼笑皆非的江湖大戏。',
  },
  {
    id: 'm-007',
    title: '暗夜行者',
    titleEn: 'Night Runner',
    year: 2024,
    region: '中国香港',
    genres: ['action', 'thriller'],
    rating: 8.0,
    duration: 118,
    director: '陈木胜',
    cast: ['古天乐', '刘青云', '林家栋'],
    releaseDate: '2024-09-20',
    heat: 7690,
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20action%20thriller%20movie%20poster%20of%20a%20man%20in%20a%20jacket%20standing%20in%20a%20neon-lit%20alley%20at%20night%2C%20deep%20blue%20shadows%20with%20orange%20neon%20glow%2C%20gritty%20urban%20mood%2C%20high%20detail&width=400&height=600&seq=movie-poster-007&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20neon-lit%20city%20alley%20at%20night%20with%20rain%20and%20deep%20blue%20shadows%2C%20warm%20orange%20neon%20signs%2C%20gritty%20action%20atmosphere%2C%20high%20detail&width=1200&height=675&seq=movie-back-007&orientation=landscape',
    synopsis: '一名游走在法律边缘的暗夜行者接下了一单看似普通的护送任务，却在二十四小时内被三条势力同时追杀。预告片里那句“天亮之前，谁都不能相信”成了整部电影的关键。',
  },
  {
    id: 'm-008',
    title: '时光信箱',
    titleEn: 'The Time Mailbox',
    year: 2025,
    region: '韩国',
    genres: ['romance', 'scifi'],
    rating: 8.5,
    duration: 124,
    director: '朴恩熙',
    cast: ['金秀贤', '孙艺珍', '李到晛'],
    releaseDate: '2025-06-06',
    heat: 8210,
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20romance%20sci-fi%20movie%20poster%20of%20a%20glowing%20vintage%20mailbox%20with%20floating%20letters%20and%20a%20lone%20figure%2C%20deep%20navy%20and%20warm%20orange%20tones%2C%20dreamy%20magical%20mood%2C%20high%20detail&width=400&height=600&seq=movie-poster-008&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20old%20post%20office%20with%20glowing%20floating%20letters%20and%20warm%20orange%20light%20streams%2C%20deep%20blue%20dreamy%20atmosphere%2C%20magical%20realism%2C%20high%20detail&width=1200&height=675&seq=movie-back-008&orientation=landscape',
    synopsis: '一台能向过去投递信件的旧信箱，让两个相隔十年的人产生了联系。他们试图改变彼此的遗憾，却发现每一次改写都会带来新的代价。',
  },
  {
    id: 'm-009',
    title: '深海之息',
    titleEn: 'Breath of the Deep',
    year: 2024,
    region: '美国',
    genres: ['animation', 'scifi'],
    rating: 9.0,
    duration: 102,
    director: '安娜·贝尔',
    cast: ['莉莉·摩根', '诺亚·里德', '汤姆·华纳'],
    releaseDate: '2024-12-13',
    heat: 9450,
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20animated%20movie%20poster%20of%20a%20young%20diver%20swimming%20among%20glowing%20deep%20sea%20creatures%2C%20deep%20navy%20ocean%20with%20warm%20orange%20bioluminescence%2C%20wonder%20and%20adventure%20mood%2C%20high%20detail&width=400&height=600&seq=movie-poster-009&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20animated%20deep%20sea%20world%20with%20glowing%20orange%20bioluminescent%20creatures%20and%20towering%20blue%20coral%2C%20wondrous%20adventure%20atmosphere%2C%20high%20detail&width=1200&height=675&seq=movie-back-009&orientation=landscape',
    synopsis: '在海底最深处，住着一个被洋流守护的声音。为了找回失踪的父亲，少女潜水员踏上了一场关于勇气与倾听的奇幻旅程。每一帧画面都像一首流动的诗。',
  },
  {
    id: 'm-010',
    title: '末日黎明',
    titleEn: 'Dawn of the End',
    year: 2025,
    region: '美国',
    genres: ['scifi', 'horror'],
    rating: 7.9,
    duration: 130,
    director: '马克·里维斯',
    cast: ['汤姆·哈迪', '艾丽西亚·维坎德', '伊桑·霍克'],
    releaseDate: '2025-10-10',
    heat: 8760,
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20post-apocalyptic%20movie%20poster%20of%20a%20lone%20survivor%20standing%20in%20a%20ruined%20city%20at%20dawn%2C%20deep%20blue%20haze%20with%20distant%20orange%20sunlight%2C%20tense%20desolate%20mood%2C%20high%20detail&width=400&height=600&seq=movie-poster-010&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20abandoned%20city%20ruins%20at%20dawn%20with%20deep%20blue%20mist%20and%20a%20band%20of%20warm%20orange%20light%20on%20the%20horizon%2C%20desolate%20tense%20atmosphere%2C%20high%20detail&width=1200&height=675&seq=movie-back-010&orientation=landscape',
    synopsis: '当城市在四十八小时内陷入黑暗，幸存者们发现恐惧本身才是真正的敌人。影片用极简的场景和紧绷的节奏，把末日叙事重新拉回到人与人之间的距离。',
  },
  {
    id: 'm-011',
    title: '长安月',
    titleEn: 'Moon over Chang-an',
    year: 2024,
    region: '中国大陆',
    genres: ['drama', 'thriller'],
    rating: 8.6,
    duration: 142,
    director: '顾长歌',
    cast: ['张译', '倪妮', '雷佳音'],
    releaseDate: '2024-04-26',
    heat: 8030,
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20historical%20chinese%20movie%20poster%20of%20a%20figure%20in%20ancient%20robes%20under%20a%20full%20moon%20above%20a%20city%20wall%2C%20deep%20blue%20night%20with%20warm%20orange%20lantern%20glow%2C%20elegant%20epic%20mood%2C%20high%20detail&width=400&height=600&seq=movie-poster-011&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20city%20walls%20at%20night%20under%20a%20huge%20moon%20with%20warm%20orange%20lanterns%20and%20deep%20blue%20sky%2C%20elegant%20epic%20atmosphere%2C%20high%20detail&width=1200&height=675&seq=movie-back-011&orientation=landscape',
    synopsis: '一桩发生在长安城的离奇命案，牵出了一场跨越十年的权谋博弈。小人物在巨大的时代洪流中试图守住心中的那轮明月，也让观众重新思考公平与代价。',
  },
  {
    id: 'm-012',
    title: '极速狂飙',
    titleEn: 'Full Throttle',
    year: 2025,
    region: '美国',
    genres: ['action'],
    rating: 8.1,
    duration: 126,
    director: '卢卡斯·福特',
    cast: ['范·迪塞尔', '杰森·斯坦森', '查理兹·塞隆'],
    releaseDate: '2025-08-22',
    heat: 8890,
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20action%20racing%20movie%20poster%20of%20a%20sleek%20sports%20car%20speeding%20through%20a%20neon%20city%20at%20night%2C%20deep%20blue%20motion%20blur%20with%20warm%20orange%20light%20streaks%2C%20explosive%20energy%2C%20high%20detail&width=400&height=600&seq=movie-poster-012&orientation=portrait',
    backdrop: 'https://readdy.ai/api/search-image?query=cinematic%20night%20city%20highway%20with%20a%20sports%20car%20speeding%20and%20warm%20orange%20light%20trails%20against%20deep%20blue%20skyscrapers%2C%20high%20energy%20atmosphere%2C%20high%20detail&width=1200&height=675&seq=movie-back-012&orientation=landscape',
    synopsis: '一场横跨三大洲的地下飙车赛事，背后是价值数十亿的芯片争夺战。老牌车手与新晋天才被迫组队，用速度赌上彼此的信任。',
  },
];